import React from 'react';
import { LanguagePicker } from '../atoms';

import styles from './Header.module.scss';
import { IconButton } from '@fluentui/react';

export interface IHeader {
	label: string;
	onClick: () => void;
}

export const Header = (props: IHeader) => {
	return (
		<div className={styles.header}>
			<h2 className={styles.title}>
				<IconButton className={styles.icon} iconProps={{ iconName: 'Home' }} onClick={props.onClick} />
				{props.label}
			</h2>
			<LanguagePicker />
		</div>
	);
};
